<template>
	<div class="Modal ModalNoticeLocation" v-if="isShow">
		<div class="Popup__background"></div>
		<div class="Modal__container">
			<div class="Modal__content">
				<h5>{{ tt('보관위치 생성하기') }}</h5>
				<p
					v-html="
						tt(
							'기관 내 <b>그룹(부서/연구실/팀)</b>을 트리구조로 등록할 수 있습니다.<br>등록한 위치에 <b>보관함</b>을 생성하고, 이 위치를 사용하는 <b>연구실/부서/팀</b>을 지정할 수 있습니다.'
						)
					"
				></p>
				<div class="imgbox">
					<img src="@/assets/images/create-2.png" />
				</div>
				<div class="btn-group">
					<button class="Btn__yellow" @click="close">
						{{ tt('시작하기') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MixinModal from '@/mixins/modal'

export default {
	name: 'ModalNoticeLocation',
	mixins: [MixinModal],
	methods: {
		show() {
			this.isShow = true
		},
		close() {
			this.$emit('hideNoticeLocation')
		},
	},
}
</script>

<style lang="scss" scoped>
.ModalNoticeLocation {
	.Modal__container {
		.Modal__content {
			padding: 40px;
			max-height: unset;
			overflow: initial;
			h5 {
				font-size: 1.5rem;
				font-weight: 700;
				width: 100%;
				text-align: left;
			}
			p {
				font-size: 0.875rem;
				color: $DEFAULT;
				margin-top: 10px;
				width: 100%;
				text-align: left;
				letter-spacing: -0.03rem;
			}
			.imgbox {
				margin: 30px 0;
				width: 600px;
				img {
					width: 100%;
				}
			}
			.Btn__yellow {
				width: 195px;
				height: 48px;
				font-size: 1rem;
				font-weight: 700;
			}
		}
	}
}
</style>
